import React, { useEffect } from "react";
import clsx from "clsx";

import { useTranslation } from "react-i18next";

import { useGetLocationData } from "~/hooks/locationData";
import Button from "~/shared/ui/Fields/Button";
import IconKrest from "~/components/Icons/icon_krest";

import IconPdf from "~/components/Icons/mimeType/icon-pdf";
import Preloader from "~/components/Preloader";

import s from "./TableRow.less";
import { SubRows } from "~/components/Table/TableRow/ZDTableRow/SubRows";
import { useDeleteLineValueDealerMutation } from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { getZDUserAccess } from "~/pages/Editor/EditorServiceAuthorization/options";
import { getRowTypeFromTableIndex } from "./options";
import { useUser } from "~/shared/context/UserContext";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

interface IProps {
  options: string[];
  arrObjects: [];
  control?;
  onSumbitDublicate?;
  selectParent?;
  onSubmit?;
  refetch?;
  loading?: boolean;
  errors?;
  handleSubmit?;
  setValue?;
  item;
  isGroupExternal?: boolean;
  parentObject?: any;
  type?: string;
}

let reFetchSave = null;

//@ts-ignore
const ZDTableRow: React.FC<IProps> = (props) => {
  const {
    options = [],
    arrObjects = [],
    control,
    onSumbitDublicate,
    selectParent,
    onSubmit,
    refetch,
    loading = false,
    errors,
    handleSubmit,
    setValue,
    item = {},
    isGroupExternal,
    parentObject,
    type,
  } = props;

  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { t } = useTranslation();
  const { openModal, currentId, event, selected } = useGetLocationData();
  const { dealerChoice } = useUser();

  // Каждый ряд знает свой тип из rowType (унифицированное поле)
  // Fallback: если rowType нет — пробуем из tableIndex, потом из URL
  const rowType =
    item.rowType ?? getRowTypeFromTableIndex(item.tableIndex) ?? selected;

  const { hasEdit, hasAnyCheck, hasAllCheck, isDealer } = getZDUserAccess(
    hasPermission,
    rowType,
    dealerChoice
  );

  // Режим «только просмотр»: нет прав на редактирование/проверку текущего пункта ЗД
  const isOnlyView = !hasEdit && !hasAnyCheck;

  const imgArr =
    item &&
    options.includes("Image") &&
    item?.Image &&
    rowType &&
    rowType !== "notes" &&
    rowType !== "personal" &&
    item?.Image.split(".");

  const isImage = (optionOneName) => {
    switch (imgArr[imgArr.length - 1]) {
      case "pdf":
        return <IconPdf />;
      default:
        return <img src={optionOneName} alt={optionOneName.label} />;
    }
  };

  const datenews =
    item.CheckedDate && item.CheckedDate.split(".").reverse().join(".");
  const CheckedDate = item.CheckedDate && new Date(datenews);

  const arrTotal = ["Note", "Year", "Total", "Country", "Model"];
  const arrTotalPersonal = [
    "PersonName",
    "Position",
    "PositionStart",
    "StudyCertificateDate",
  ];

  const isDisabled =
    onSumbitDublicate &&
    !item.forUUID &&
    Object.keys(item).filter((els) => {
      return (
        (rowType === "personal"
          ? arrTotalPersonal.includes(els)
          : arrTotal.includes(els)) && !item[els]
      );
    }).length === (rowType === "personal" ? 4 : 5);

  const isDisabledBut =
    (onSumbitDublicate &&
      rowType !== "personal" &&
      !item.forUUID &&
      item.list.filter((el) => {
        return !el.Note && !el.Year && !el.Total && !el.Country && !el.Model;
      })) ||
    [];

  const isDisabledButPersonal =
    (onSumbitDublicate &&
      rowType === "personal" &&
      !item.forUUID &&
      Array.isArray(item?.list) &&
      item?.list.filter((el) => {
        return (
          !el.PersonName &&
          !el.PositionStart &&
          !el.Position &&
          !el.StudyCertificateDate
        );
      })) ||
    [];

  const isGroup = isGroupExternal || (onSumbitDublicate && !item.forUUID);

  const DealerId = useCurrentDealerId();
  const [deleteLineDealer] = useDeleteLineValueDealerMutation({
    onCompleted: () => {
      reFetchSave && reFetchSave();
    },
  });

  useEffect(() => {
    if (!!refetch) reFetchSave = refetch;
  }, [refetch]);

  const handleDeleteRow = (ZD_UUID: string) => () => {
    deleteLineDealer({
      variables: {
        tableIndex: item.tableIndex,
        DealerId: item.DealerId,
        ZD_UUID,
      },
    });
  };

  const excludedAddButton = ["personal"];

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <>
          {item.isOneParrent && (
            <tr
              className={clsx(s.row_tr, {
                [s.row_group_glav]: item.isOneParrent,
              })}
            >
              <td
                colSpan={
                  selectParent === "tools" && (hasEdit || hasAllCheck)
                    ? options.length + 2
                    : options.length + 1
                }
              >
                {rowType === "places" || rowType === "tradePremises"
                  ? t(`zd.${item.GroupOne}`)
                  : item.GroupOne}
              </td>
            </tr>
          )}
          {isGroup && (
            <>
              <tr
                className={clsx(s.row_tr, {
                  [s.row_group]: isGroup,
                  // [s.row_group_glav]: item.isOneParrent,
                })}
              >
                <td
                  className={clsx({
                    [s.td_colspan]: isGroup && (hasEdit || hasAllCheck),
                  })}
                  colSpan={
                    isGroup && (hasEdit || hasAllCheck)
                      ? options.length + 1
                      : options.length
                  }
                >
                  {/*<td colSpan={options.length}>*/}
                  {options?.map((optionName) =>
                    optionName === "Name" || optionName === "Number"
                      ? optionName === "Number"
                        ? item.ParentId !== "0" || item.ParentId !== null
                          ? item.parentNumber
                            ? `${item.parentNumber}.${item[optionName]}.`
                            : `${item[optionName]}. `
                          : item[optionName]
                          ? `${item[optionName]}. `
                          : ""
                        : item[optionName]
                      : " "
                  )}
                </td>

                <td className={s.icon_min}>
                  {!excludedAddButton.includes(rowType) &&
                    isGroup &&
                    (hasEdit || hasAllCheck) && (
                      <div>
                        <Button
                          small
                          onlyIcon
                          orange
                          loading={loading}
                          disabled={
                            isDisabled ||
                            (rowType === "personal"
                              ? isDisabledButPersonal.length > 0
                              : isDisabledBut.length > 0)
                          }
                          txtBtn={""}
                          customClassName={clsx(s.wide_btn, s.btn_small_icon)}
                          onClick={() => onSumbitDublicate(item.UUID)}
                        >
                          <IconKrest />
                        </Button>
                      </div>
                    )}
                  </td>
              </tr>
            </>
          )}

          {rowType === "requiredTools" || rowType === "personal" ? (
            isGroup ? (
              <></>
            ) : (
              <SubRows.DefaultOldSubRow
                {...{
                  // fields
                  arrObjects,
                  item,
                  options,
                  openModal,
                  currentId,
                  control,
                  selected,
                  rowType,
                  datenews,
                  imgArr,
                  loading,

                  // actions
                  onSubmit,
                  handleSubmit,
                  setValue,
                  selectParent,
                  errors,
                  onSumbitDublicate,

                  // permissions
                  hasEdit,
                  hasAnyCheck,
                  hasAllCheck,
                  isOnlyView,
                  isImage,
                  CheckedDate,
                  handleDeleteRow,
                  parentObject,
                  type,
                }}
              />
            )
          ) : (
            <SubRows.DefaultOldSubRow
              {...{
                // fields
                arrObjects,
                item,
                options,
                openModal,
                currentId,
                control,
                selected,
                rowType,
                datenews,
                imgArr,
                loading,

                // actions
                onSubmit,
                handleSubmit,
                setValue,
                selectParent,
                errors,
                onSumbitDublicate,

                // permissions
                hasEdit,
                hasAnyCheck,
                hasAllCheck,
                isImage,
                isOnlyView,
                CheckedDate,
                handleDeleteRow,
                parentObject,
                type,
              }}
            />
          )}
        </>
      )}
    </>
  );
};
export default ZDTableRow;
